import axios from 'axios';
import config from '$config';
import { getIdToken } from '$app/auth';
import { getStoredSelectedSegment } from '$app/segmentSelection';

export const api = axios.create({
  baseURL: config.gateUrl,
  headers: {
    'x-api-key': config.apiKey,
  }
});

function requestInterceptor(config) {
  // UI-selected segment: sent on every request so backends can scope data without a
  // per-endpoint query param. Only narrows the authorizer-allowed set (x-segments).
  const segment = getStoredSelectedSegment();
  if (segment) {
    config.headers['x-selected-segment'] = segment;
  }
  return getIdToken()
    .then(jwtToken => {
      config.headers.Authorization = jwtToken;
      return config;
    });
}

api.interceptors.request.use(requestInterceptor);